import React from "react";
import { FormGroup } from "reactstrap";
import { Icon } from "react-icons-kit";
import { calendar } from "react-icons-kit/fa/calendar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/scss/components/CustomDatepicker/index.scss";

export default function customDatePicker(props) {
  let { value } = props;
  let { handleDateChange } = props;
  return (
    <React.Fragment>
      <FormGroup className="inputWrpper customDatepicker">
        {/* <Label>{labelName}</Label> */}

        <div className="position-relative">
          <DatePicker
            onChange={handleDateChange}
            className={"form-control dateSpace"}
            dateFormat="dd/MM/yyyy"
            placeholderText={props.customPlaceHolder}
            selected={value}
            name="dob"
            autoComplete="off"
            showMonthDropdown={props.customShowMonthDropdown}
            showYearDropdown={props.customShowYearDropdown}
            showTimeSelect={props.customTimeSelect}
            showTimeSelectOnly={props.customTimeSelectOnly}
            scrollableYearDropdown={true}
            maxDate={props.customMaxDate}
            minDate={props.customMinDate}
            dropdownMode="select"
            disabled={props.customDisable}
            onKeyDown={(e) => {
              e.preventDefault();
            }}
            onBeforeInput={(e) => {
              e.preventDefault();
            }}
          />
          <Icon className="text-dark dateIcon" size={18} icon={calendar} />
        </div>
      </FormGroup>
    </React.Fragment>
  );
}
